import Vue from 'vue';
import VueRouter from 'vue-router';

import { userTokenUrl } from '@routes';
import * as constants from '@constants';

Vue.use(VueRouter);

const routes = [
    {
        path: `/super-admin/${constants.SUPER_ADMIN_HASH}/`,
        component: () => import('../views/SuperAdmin/Base'),
        beforeEnter: (to, from, next) => {
            const token = localStorage.getItem('accessToken');

            if (token) {
                Vue.axios.get(userTokenUrl()).then(() => {
                    next();
                }).catch(() => {
                    next({ name: 'SuperAdminLogin', params: to.params, replace: true });
                });
            } else {
                next({ name: 'SuperAdminLogin', params: to.params, replace: true });
            }
        },
        children: [
            {
                path: 'membership/:id/edit',
                name: 'MembershipEdit',
                component: () => import('../views/SuperAdmin/Membership/Form')
            }
        ]
    },
    {
        path: `/super-admin/${constants.SUPER_ADMIN_HASH}/login`,
        name: 'SuperAdminLogin',
        component: () => import('../views/SuperAdmin/Login'),
        beforeEnter: (to, from, next) => {
            const token = localStorage.getItem('accessToken');

            if (token) {
                Vue.axios.get(userTokenUrl()).then(() => {
                    next({ name: 'Membership', replace: true });
                }).catch(() => {
                    next();
                });
            } else {
                next();
            }
        }
    },
    {
        path: '/:memberName/login',
        name: 'PortalLogin',
        component: () => import('../views/Login'),
        beforeEnter: (to, from, next) => {
            const token = localStorage.getItem('accessToken');
            const application = localStorage.getItem('application');

            if (token && application === constants.PORTAL_USER) {
                Vue.axios.get(userTokenUrl(), { params: { application }}).then(() => {
                    next({ name: 'PortalPublication', params: { memberName: to.params.memberName }, replace: true });
                }).catch(() => {
                    next();
                });
            } else {
                next();
            }
        }
    },
    {
        path: '/:memberName/admin/login',
        name: 'BackOfficeLogin',
        component: () => import('../views/Login'),
        beforeEnter: (to, from, next) => {
            const token = localStorage.getItem('accessToken');
            const application = localStorage.getItem('application');

            if (token && application === constants.BACK_OFFICE_USER) {
                Vue.axios.get(userTokenUrl(), { params: { application }}).then(() => {
                    next({ name: 'PortalPublication', params: { memberName: to.params.memberName }, replace: true });
                }).catch(() => {
                    next();
                });
            } else {
                next();
            }
        }
    },
    {
        path: '/:memberName/admin/',
        component: () => import('../views/BackOffice/Base'),
        beforeEnter: (to, from, next) => {
            const token = localStorage.getItem('accessToken');
            const application = localStorage.getItem('application');

            if (token && application === constants.BACK_OFFICE_USER) {
                Vue.axios.get(userTokenUrl(), { params: { application }}).then(() => {
                    next();
                }).catch(() => {
                    next({ name: 'BackOfficeLogin', params: { memberName: to.params.memberName }, replace: true });
                });
            } else {
                next({ name: 'BackOfficeLogin', params: { memberName: to.params.memberName }, replace: true });
            }
        },
        children: [
            {
                path: 'publication',
                name: 'Publication',
                component: () => import('../views/BackOffice/Publication/Index')
            },
            {
                path: 'publication/new',
                name: 'PublicationNew',
                component: () => import('../views/BackOffice/Publication/Form')
            },
            {
                path: 'publication/:id/edit',
                name: 'PublicationEdit',
                component: () => import('../views/BackOffice/Publication/Form')
            },
            {
                path: 'publication/:id/show',
                name: 'PublicationShow',
                component: () => import('../views/BackOffice/Publication/Show')
            },
            {
                path: 'profile',
                name: 'Profile',
                component: () => import('../views/Profile')
            },
            {
                path: 'settings',
                name: 'Settings',
                component: () => import('../views/BackOffice/Setting')
            },
            {
                path: 'user/new',
                name: 'UserNew',
                component: () => import('../views/BackOffice/User/Form')
            },
            {
                path: 'user/:id/edit',
                name: 'UserEdit',
                component: () => import('../views/BackOffice/User/Form')
            },
            {
                path: 'user/:id/show',
                name: 'UserShow',
                component: () => import('../views/BackOffice/User/Show')
            },
            {
                path: 'customer',
                name: 'Customer',
                component: () => import('../views/BackOffice/Customer/Index')
            },
            {
                path: 'customer/new',
                name: 'CustomerNew',
                component: () => import('../views/BackOffice/Customer/Form')
            },
            {
                path: 'customer/:id/edit',
                name: 'CustomerEdit',
                component: () => import('../views/BackOffice/Customer/Form')
            },
            {
                path: 'customer/:id/show',
                name: 'CustomerShow',
                component: () => import('../views/BackOffice/Customer/Show')
            },
            {
                path: 'portal-user/:customerId/new',
                name: 'PortalUserNew',
                component: () => import('../views/BackOffice/User/Form')
            },
            {
                path: 'portal-user/:customerId/:id/edit',
                name: 'PortalUserEdit',
                component: () => import('../views/BackOffice/User/Form')
            },
            {
                path: 'portal-user/:id/show',
                name: 'PortalUserShow',
                component: () => import('../views/BackOffice/User/Show')
            },
            {
                path: 'group/:customerId/new',
                name: 'GroupNew',
                component: () => import('../views/BackOffice/Group/Form')
            },
            {
                path: 'group/:id/edit',
                name: 'GroupEdit',
                component: () => import('../views/BackOffice/Group/Form')
            }
        ]
    },
    {
        path: '/:memberName/',
        component: () => import('../views/Portal/Base'),
        beforeEnter: (to, from, next) => {
            const token = localStorage.getItem('accessToken');
            const application = localStorage.getItem('application');

            if (token && application === constants.PORTAL_USER) {
                Vue.axios.get(userTokenUrl(), { params: { application }}).then(() => {
                    next();
                }).catch(() => {
                    next({ name: 'PortalLogin', params: to.params, replace: true });
                });
            } else {
                next({ name: 'PortalLogin', params: to.params, replace: true });
            }
        },
        children: [
            {
                path: '',
                name: 'PortalPublication',
                component: () => import('../views/Portal/Publication')
            },
            {
                path: 'profile',
                name: 'PortalProfile',
                component: () => import('../views/Profile')
            },
            {
                path: 'file/:encryptedName',
                name: 'FileDownload',
                component: () => import('../views/Portal/Publication')
            }
        ]
    },
    {
        path: '*',
        component: () => import('../views/Home'),
        beforeEnter: (to, from, next) => {
            const token = localStorage.getItem('accessToken');
            const application = localStorage.getItem('application');

            if (token && (application === constants.PORTAL_USER || application === constants.BACK_OFFICE_USER)) {
                Vue.axios.get(userTokenUrl(), { params: { application }}).then(() => {
                    next();
                }).catch(() => {
                    next({ name: application === constants.PORTAL_USER ? 'PortalLogin' : 'BackOfficeLogin', params: to.params, replace: true });
                });
            } else {
                next({ name: 'Home', params: to.params, replace: true });
            }
        }
    }
];

const router = new VueRouter({
    mode: 'history',
    routes
});

export default router;
